const headerMenuConfig = [];

const asideMenuConfig = [
  // {
  //   name: "营销中心",
  //   category: "cjyx-new",
  //   children: [
  //     {
  //       name: "首页概览",
  //       path: "/web/cjyx-new/home",
  //     },
  //     {
  //       name: "客户管理",
  //       path: "/web/cjyx-new/CustomerManagement",
  //     },
  //     {
  //       name: "精准营销",
  //       children: [
  //         {
  //           name: "官方人群营销",
  //           path: "/web/cjyx-new/crowdMarketing",
  //         },
  //         {
  //           name: "云鹿人群营销",
  //           path: "/web/cjyx-new/privateCrowdMarketing",
  //         },
  //         {
  //           name: "订单筛选营销",
  //           path: "/web/cjyx-new/orderSelection",
  //         },
  //       ],
  //     },
  //     {
  //       name: "订单关怀",
  //       path: "/web/cjyx-new/care",
  //     },
  //     {
  //       name: "账户管理",
  //       children: [
  //         {
  //           name: "账户管理",
  //           path: "/web/cjyx-new/accountKeeper",
  //         },
  //         {
  //           name: "短信消耗记录",
  //           path: "/web/cjyx-new/sms/consumption",
  //         },
  //       ],
  //     },
  //     {
  //       name: "短信模板",
  //       path: "/web/cjyx-new/smstemplate",
  //     },
  //   ],
  // },
  {
    name: "会员中心",
    category: "crm",
    layout: "crm",
    children: [
      {
        name: "会员管理",
        path: "/web/crm/member",
        icon: "account",
        children: [
          {
            name: "会员列表",
            path: "/web/crm/member/list",
          },
          {
            name: "会员等级管理",
            path: "/web/crm/member/level",
          },
          {
            name: "会员积分管理",
            path: "/web/crm/member/points",
          },
        ],
      },
      {
        name: "会员数据",
        path: "/web/crm/report",
        icon: "chart-pie",
        children: [
          {
            name: "新增会员分析",
            path: "/web/crm/report/increased",
          },
          {
            name: "会员活跃分析",
            path: "/web/crm/report/active",
          },
          {
            name: "会员贡献分析",
            path: "/web/crm/report/contribute",
          },
          {
            name: "会员等级分析",
            path: "/web/crm/report/level",
          },
        ],
      },
    ],
  },
  {
    name: "数据中心",
    category: "customdata",
    layout: "crm",
    hasBreadcrumb: true,
    children: [
      {
        name: "定制报表",
        path: "/web/customdata/yili",
        icon: "icon-a-outline51",
        children: [
          {
            name: "用户成交报表",
            path: "/web/customdata/yili/douYinMaternalDataboard",
          },
        ],
      },
    ],
  },
];

export { headerMenuConfig, asideMenuConfig };

